import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-empfilterlist',
  templateUrl: './empfilterlist.component.html',
  styleUrls: ['./empfilterlist.component.css']
})
export class EmpfilterlistComponent implements OnInit {


  @Input() filterstatus: string = "ALL";
  @Input() filteremployeeid: any = 0;
  @Input() filteremployeename: string = "";
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() filterdesignationid: any = 0;
  @Input() filterdesignationname: string = "";
  @Input() filterpayrollgrpid: any = 0;
  @Input() filterpayrollgrpname: string = "";
  @Input() filterbranchid: any = 0;
  @Input() filterbranchname: string = "";
  @Input() filterdepartmentid: any = 0;
  @Input() filterdepartmentname: string = "";
  @Input() filterlocationid: any = 0;
  @Input() filterlocationname: string = "";
  @Input() filternationalityid: any = 0;
  @Input() filternationality: string = "";
  @Input() formname: string = "";


  @Output() cbapplyChanged = new EventEmitter();
  @Output() filterChanged = new EventEmitter<number>();

  statusColl: any = [];


  constructor() { }


  ngOnInit() {
    this.fngetStatus();
  }


  fngetStatus() {
    this.statusColl.push({ displayname: "Active", value: "" });
    this.statusColl.push({ displayname: "InActive", value: "INACTIVE" });
    this.statusColl.push({ displayname: "All", value: "ALL" });
  }

  fnApplyFilter() {

    var _data = {
      status: this.filterstatus
    }

    this.cbapplyChanged.emit(_data);

  }

  fnRemoveFilter(type) {

    if (type === "EMPLOYEE") {
      this.filteremployeeid = 0;
      this.filteremployeename = "";
    }
    else if (type === "FROMDATE") {
      this.filterfromdate = null;
    }
    else if (type === "TODATE") {
      this.filtertodate = null;
    } 
     else if (type === "DESIGNATION") {
      this.filterdesignationid = null;
      this.filterdesignationname = "";
    }
    else if (type === "BRANCH") {
      this.filterbranchid = 0;
      this.filterbranchname = "";
    }
    else if (type === "DEPARTMENT") {
      this.filterdepartmentid = 0;
      this.filterdepartmentname = "";
    }
    else if (type === "LOCATION") {
      this.filterlocationid = 0;
      this.filterlocationname = "";
    }
    else if (type === "NATIONALITY") {
      this.filternationalityid = 0;
      this.filternationality = "";
    }


    else {
      this.filteremployeeid = 0;
      this.filteremployeename = "";
      this.filterfromdate = null;
      this.filtertodate = null;
      this.filterdesignationid = 0;
      this.filterdesignationname = "";
      this.filterpayrollgrpid = 0;
      this.filterpayrollgrpname = "";
      this.filterbranchid = 0;
      this.filterbranchname = "";
      this.filterdepartmentid = 0;
      this.filterdepartmentname = "";
      this.filterlocationid = 0;
      this.filterlocationname = "";
      this.filternationalityid = 0;
      this.filternationality = "";
    }



    var _data = {
      empid: this.filteremployeeid,
      empname: this.filteremployeename,
      fromdate: this.filterfromdate,
      todate: this.filtertodate,
      designationid: this.filterdesignationid,
      designationname: this.filterdesignationname,
      payrollgrpid: this.filterpayrollgrpid,
      payrollgrpname: this.filterpayrollgrpname,
      branchid: this.filterbranchid,
      branchname: this.filterbranchname,
      departmentid: this.filterdepartmentid,
      departmentname: this.filterdepartmentname,
      locationid: this.filterlocationid,
      locationname: this.filterlocationname,
      nationalityid: this.filternationalityid,
      nationality: this.filternationality,
    }

    this.cbapplyChanged.emit(_data);
  }

}
